import useLookupListData from "@app/data-hooks/use-lookup-list-data.ts";
import useStaffData from "@app/data-hooks/use-staff-data.ts";
import useAuth from "@app/hooks/use-auth.ts";
import { Button, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";
import { QueryStatusRouter, Select } from "bi-lib";
import { useEffect, useMemo, useState } from "react";

export default function AccountProfileForm() {
    const [utilizationCodeId, setUtilizationCodeId] = useState<number>(2);
    const [assignments, setAssignments] = useState<number[]>([]);

    const { userData } = useAuth();

    const staffId = useMemo(() => userData?.UserId, [userData]);

    const { utilizationCodesList } = useLookupListData();
    const { saveProfile, profileList } = useStaffData({ id: staffId, utilId: utilizationCodeId });

    useEffect(() => {
        const data =
            profileList.data?.reduce<number[]>((acc, x) => {
                if (x.isSelected) {
                    return [...acc, x.assignmentId!];
                }
                return acc;
            }, []) ?? [];
        setAssignments(data);
    }, [profileList.data]);

    const handleSave = () => {
        saveProfile.mutate({
            assignments: assignments.join(","),
            staffingId: staffId,
            utilId: utilizationCodeId,
        });
    };

    const toggleItem = (id: number) => {
        const tempAssignments = [...assignments];
        const index = tempAssignments.indexOf(id);
        if (index == -1) {
            tempAssignments.push(id);
            setAssignments(tempAssignments);
            return;
        }
        tempAssignments.splice(index, 1);
        setAssignments(tempAssignments);
    };

    return (
        <Stack spacing={1}>
            <Typography>Please select the assignments to show in assignments list:</Typography>
            <Typography fontStyle={"italic"}>
                <b>(R)</b> indicates in the assignments roster.
            </Typography>
            <QueryStatusRouter queryHook={utilizationCodesList}>
                <Select
                    label={"Utilization Code"}
                    value={utilizationCodeId}
                    onChange={(e) => setUtilizationCodeId(e!)}
                    fullWidth
                    sx={{ maxWidth: 500 }}
                    options={utilizationCodesList.data?.map((x) => ({
                        label: x.displayName,
                        value: x.utilizationCodeId,
                    }))}
                />
            </QueryStatusRouter>
            <QueryStatusRouter queryHook={profileList}>
                {profileList.data?.map((x) => (
                    <FormControlLabel
                        key={x.assignmentId}
                        control={
                            <Checkbox
                                checked={assignments.includes(x.assignmentId!)}
                                onChange={() => toggleItem(x.assignmentId!)}
                            />
                        }
                        label={x.displayName}
                    />
                ))}
            </QueryStatusRouter>
            <Button variant={"contained"} onClick={handleSave}>
                Save
            </Button>
        </Stack>
    );
}
